import script from "./WishesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WishesModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__